import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { VideoComponent } from "@hermes/aphrodite/video";

import { ImageResizerModule } from "@hermes/fragments/image-resizer";

import { VtoModalServiceModule } from "@hermes/fragments/vto-button";
import { MediaCtaModule } from "@hermes/media-cta";

import { TrustHtmlPipeModule } from "@hermes/utils-generic/pipes/trust-html";

import { GridEditoComponent } from "./components/grid-edito/grid-edito.component";
import { GridEditoContentComponent } from "./components/grid-edito-content/grid-edito-content.component";

@NgModule({
    imports: [
        CommonModule,
        VideoComponent,
        ImageResizerModule,
        MediaCtaModule,
        TrustHtmlPipeModule,
        VtoModalServiceModule,
    ],
    declarations: [GridEditoComponent, GridEditoContentComponent],
    exports: [GridEditoComponent],
})
export class GridEditoModule {}
